@use "variables" as *;

.mainContent {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
}

.title {
  font-size: $fontSize-l;
  margin: $spacing-s $spacing-m $spacing-s $spacing-s;
}

.toolbar {
  padding-left: $spacing-s;
  padding-right: $spacing-s;
}

.searchBar {
}

.mainCard {
  margin: $spacing-m $spacing-m $spacing-s $spacing-m;
  display: flex;
  position: relative;
  overflow: auto;
  height: calc(96% - #{$appBarHeight});
}

.mainList {
  width: 100%;
  padding: $spacing-l !important;
  overflow: auto;
}

.sectionTitle {
  margin-left: $spacing-s;
  font-size: $fontSize-ml;
  font-weight: bold;
}

.publicCollectionsCard {
  padding: $spacing-m;
  margin-top: $spacing-m;
  margin-bottom: $spacing-m;
}

.credits {
  margin-right: $spacing-s;
}
